import { Typography } from 'antd';

const Label = ({children})=> {
    return <Typography.Title level={5}>{children}</Typography.Title>
}

export default Label;